import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  IonButton,
  IonButtons,
  IonItem,
  IonLabel,
  IonList,
} from '@ionic/react';
import PayActions, { PaySelectors } from 'redux/PayRedux';
import get from 'lodash/get';

function SlideItem({ promotion }) {
  const dispatch = useDispatch();
  const ticket = useSelector(PaySelectors.selectTicket);
  
  const isAnnualOffer = useMemo(() => {
    return promotion?.offer?.offer_type === 'annual';
  }, [promotion]);

  const handleApply = () => {
    if (isAnnualOffer) {
      dispatch(PayActions.applyOfferDiscount(promotion.offerId));
    } else {
      dispatch(PayActions.applyPromotion(promotion.id));
    }
  };
  
  const isSelected = get(ticket, `promotions.${promotion.id}`);

  return (
    <IonList className={isAnnualOffer ? "promotions__slide promotions__slide_annual" : "promotions__slide"}>
      <IonItem lines="none" className="promotions__slide-item">
        <IonLabel className="promotions__slide-title ion-text-wrap">
          {isAnnualOffer ? promotion.offer.annual_event_type === 'birthday' ? "Birthday Reward" : "Anniversary Reward" : promotion.name}
        </IonLabel>

        <IonButtons slot="end">
          {!isSelected ? (
            <IonButton color="tertiary" onClick={handleApply}>
              Redeem
            </IonButton>
          ) : (
            <IonButton disabled>Redeemed</IonButton>
          )}
        </IonButtons>
      </IonItem>
    </IonList>
  );
}

SlideItem.propTypes = {
  promotion: PropTypes.object,
};

export default SlideItem;
